import Login from './Login'
const routes: IRoute[] = [
	{
		path: '/login',
		component: Login,
		layout: 'public',
		name: '登录',
	},
]
export default routes
import UserContext, { IUserContext, UserProvider } from './UserContext'
export { UserContext, IUserContext, UserProvider }



// WEBPACK FOOTER //
// ./src/modules/User/index.ts